import React from 'react'
import CRUD from '../../components/common/CRUD/CRUD'
import { fields } from '../../models/financialResources/tagSchemaClassGoalModel'
import { createCRUDService } from '../../services/crudService'
import { Breadcrumb } from 'react-bootstrap'

const { listItems, deleteItem, createItem, updateItem } = createCRUDService(
  '/api/financial_resources/goals'
)

const TagSchemaClassGoalsView = () => {
  return (
    <main style={{ padding: '1rem 0' }}>
      {/* eslint-disable-next-line react/jsx-pascal-case */}
      <CRUD
        fields={fields}
        paginated
        entityName='meta etiqueta financiera'
        entityNamePlural='metas etiquetas financieras'
        dataSource={listItems}
        onDelete={deleteItem}
        onCreate={createItem}
        onUpdate={updateItem}
        useTable
      />
    </main>
  )
}

TagSchemaClassGoalsView.breadcrumbs = () => (
  <Breadcrumb.Item key='breadcrumb-expenses' href='/bank_accounts' active>
    Cuentas Bancarias
  </Breadcrumb.Item>
)

export default TagSchemaClassGoalsView
